import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import SequenceBarItem from 'Components/UI/SequenceBarItem';
import { fade } from '@material-ui/core';
import MuiFiberManualRecord from '@material-ui/icons/FiberManualRecord';
import MuiIconButton from '@material-ui/core/IconButton';

const styles = theme => ({
  root: {
    width: '100%',
    alignItems: 'center',
  },
  footerText: {
    ...theme.typography.h6,
    fontWeight: theme.typography.fontWeightBold,
    color: fade(theme.palette.facet.primaryGray, 0.8),
    marginBottom: 'unset',
  },
  icon: {
    color: fade(theme.palette.facet.primaryGray, 0.8),
  },
});

const SequenceBarButton = ({
  classes,
  className,
  onClick,
}) => {
  return (
    <SequenceBarItem
      className={classNames(classes.root, className)}
      footer={
        <>
          <div className={classNames(classes.footerText)}>
            Share Schedule New Meeting Link
          </div>
        </>
      }
    >
      <MuiIconButton
        className={classes.icon}
        onClick={onClick}
      >
        <MuiFiberManualRecord />
      </MuiIconButton>
    </SequenceBarItem>
  );
};

SequenceBarButton.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

SequenceBarButton.defaultProps = {
  className: '',
};

export default withStyles(styles)(SequenceBarButton);
